import { GridActionHandlerBase } from "./grid-action-handler-base";

/**
 * Loads data, keeping the current filter and page
 */
export class LoadDataKeepFilterGridActionHandler extends GridActionHandlerBase {
  /**
  /**
  * Handles an event
  * @param _payload The (untyped) payload. Can also be a callback function
  */
  public handle(_payload: any): void{
    const savedOid = _payload?.m_Item2;
    this.workspace.grid.applyFilter(this.workspace.grid.state.filter, savedOid);
  }
}
